import { createAsyncThunk } from "@reduxjs/toolkit";
import { useCustomAxios } from "../../shared/lib/customAxios";
import { API_ENDPOINTS } from "../../shared/constants/constants";

export const createCommEvent = createAsyncThunk(
  "commEvent/create",
  async (reqBody: any, { rejectWithValue }) => {
    const { axiosPost } = useCustomAxios();
    const url = `${API_ENDPOINTS.createCommEvent}`;
    try {
      const response = await axiosPost(url, reqBody);
      return { data: response.data, status: response.status };
    } catch (error: any) {
      return rejectWithValue(error.response.data.message);
    }
  }
);

export const getCommEventThread = createAsyncThunk(
  "get/commThread",
  async (obj: any, { rejectWithValue }) => {
    const { axiosGet } = useCustomAxios();
    let url = `${API_ENDPOINTS.getCommThread}`;
    url = url.replace(":referenceId", obj?.referenceId);
    url = url.replace(":commEventType", obj?.commEventType);
    try {
      const response = await axiosGet(url);
      return { data: response.data, status: response.status };
    } catch (error: any) {
      return rejectWithValue(error.response.data);
    }
  }
);
